var map = {
	"./Nocne (1).jpg": 1203,
	"./Nocne (11).jpg": 3326,
	"./Restoran_vani (1).jpg": 1211,
	"./SOBA_102 (1).jpg": 9553,
	"./SOBA_104 (3).jpg": 3049,
	"./SOBA_204 (1).jpg": 2516,
	"./SOBA_301 (2).jpg": 4041,
	"./SOBA_303 (2).jpg": 9099,
	"./SOBA_304 (4).jpg": 1262,
	"./VANJSKE (2).jpg": 8983,
	"./VANJSKE (5).jpg": 9726,
	"./VANJSKE (6).jpg": 9875,
	"./VANJSKE (7).jpg": 9104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9130;